import { render } from "./NewBookingsView.vue?vue&type=template&id=1793c816&scoped=true"
import script from "./NewBookingsView.vue?vue&type=script&lang=js"
export * from "./NewBookingsView.vue?vue&type=script&lang=js"

import "./NewBookingsView.vue?vue&type=style&index=0&id=1793c816&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1793c816"]])

export default __exports__